import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { toast } from '@grandvisionhq/common';
import { useIntl, useSelector } from '@grandvisionhq/state';
import { GooglePaySessionErrors } from '../../../../../mappers/errors-mapping.js';
import { getSelectedPickupPoint, getSelectedStore } from '../../../../../StepShipping/selectors.js';
import 'lodash/isEmpty';
import '@grandvisionhq/utils';
import '../../../../../utils/get-customer-details-payload.js';
import { isNearestPickup, isPickupPoint, isPickupStore } from '../../../../../utils/shipping-method.js';
import 'history';
import '../../../../../models/cart/cart-state.js';
import '../../../../../models/checkout/checkout-step-error-type.js';
import '../../../../../models/checkout-settings.js';
import '../../../../../models/step-shipping/shipping-methods.js';
import '../../../../../models/shared.js';
import '../../../../../utils/has-cart-errors.js';
import { mapGooglePayContactAddress } from '../mappers/google-pay-contact-address.js';

const useMapShippingAddress = ()=>{
    const { country , getLabel  } = useIntl();
    const { cart  } = Context.useCart();
    const selectedPickupPoint = useSelector(getSelectedPickupPoint);
    const selectedStore = useSelector(getSelectedStore);
    const shippingMethodRef = React.useRef(cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key);
    const selectedStoreRef = React.useRef(selectedStore);
    const selectedPickupPointRef = React.useRef(selectedPickupPoint);
    React.useEffect(()=>{
        shippingMethodRef.current = cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key;
    }, [
        cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key
    ]);
    React.useEffect(()=>{
        selectedStoreRef.current = selectedStore;
    }, [
        selectedStore
    ]);
    React.useEffect(()=>{
        selectedPickupPointRef.current = selectedPickupPoint;
    }, [
        selectedPickupPoint
    ]);
    return React.useCallback((googlePayment)=>{
        var ref;
        const billingAddress = (ref = googlePayment.paymentMethodData.info) === null || ref === void 0 ? void 0 : ref.billingAddress;
        // A billing address is always required
        if (!billingAddress || !cart) {
            return;
        }
        const shippingMethod = shippingMethodRef.current;
        const isNearestPickup$1 = isNearestPickup(shippingMethod);
        const isPickupPoint$1 = isPickupPoint(shippingMethod);
        const isStorePickUp = isPickupStore(shippingMethod);
        if (isNearestPickup$1) {
            if (billingAddress.countryCode !== country) {
                toast.failed(GooglePaySessionErrors.GooglePayInvalidAddress);
                throw getLabel(GooglePaySessionErrors.GooglePayInvalidAddress);
            }
            return mapGooglePayContactAddress(googlePayment, 'billingAddress');
        }
        if (isPickupPoint$1) {
            var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
            const contactAddress = mapGooglePayContactAddress(googlePayment);
            var ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
            return swcHelpers.objectSpread({}, contactAddress, {
                firstName: (ref9 = contactAddress === null || contactAddress === void 0 ? void 0 : contactAddress.firstName) !== null && ref9 !== void 0 ? ref9 : '',
                lastName: (ref10 = contactAddress === null || contactAddress === void 0 ? void 0 : contactAddress.lastName) !== null && ref10 !== void 0 ? ref10 : '',
                city: (ref11 = (ref1 = selectedPickupPointRef.current) === null || ref1 === void 0 ? void 0 : ref1.town) !== null && ref11 !== void 0 ? ref11 : '',
                streetName: (ref12 = (ref2 = selectedPickupPointRef.current) === null || ref2 === void 0 ? void 0 : ref2.streetName) !== null && ref12 !== void 0 ? ref12 : '',
                streetNumber: (ref13 = (ref3 = selectedPickupPointRef.current) === null || ref3 === void 0 ? void 0 : ref3.streetNumber) !== null && ref13 !== void 0 ? ref13 : undefined,
                postalCode: (ref14 = (ref4 = selectedPickupPointRef.current) === null || ref4 === void 0 ? void 0 : ref4.postalCode) !== null && ref14 !== void 0 ? ref14 : '',
                additionalAddressInfo: '',
                additionalStreetInfo: (ref15 = (ref5 = selectedPickupPointRef.current) === null || ref5 === void 0 ? void 0 : ref5.additionalStreetInfo) !== null && ref15 !== void 0 ? ref15 : '',
                countryCode: (ref16 = (ref6 = selectedPickupPointRef.current) === null || ref6 === void 0 ? void 0 : ref6.country) !== null && ref16 !== void 0 ? ref16 : '',
                externalId: (ref17 = (ref7 = selectedPickupPointRef.current) === null || ref7 === void 0 ? void 0 : ref7.globalPickupPointId) !== null && ref17 !== void 0 ? ref17 : undefined,
                company: (ref18 = (ref8 = selectedPickupPointRef.current) === null || ref8 === void 0 ? void 0 : ref8.name) !== null && ref18 !== void 0 ? ref18 : undefined
            });
        }
        if (isStorePickUp) {
            var ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26;
            const contactAddress = mapGooglePayContactAddress(googlePayment);
            var ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36;
            return swcHelpers.objectSpread({}, contactAddress, {
                firstName: (ref27 = contactAddress === null || contactAddress === void 0 ? void 0 : contactAddress.firstName) !== null && ref27 !== void 0 ? ref27 : '',
                lastName: (ref28 = contactAddress === null || contactAddress === void 0 ? void 0 : contactAddress.lastName) !== null && ref28 !== void 0 ? ref28 : '',
                city: (ref29 = (ref19 = selectedStoreRef.current) === null || ref19 === void 0 ? void 0 : ref19.town) !== null && ref29 !== void 0 ? ref29 : '',
                streetName: (ref30 = (ref20 = selectedStoreRef.current) === null || ref20 === void 0 ? void 0 : ref20.streetName) !== null && ref30 !== void 0 ? ref30 : '',
                streetNumber: (ref31 = (ref21 = selectedStoreRef.current) === null || ref21 === void 0 ? void 0 : ref21.streetNumber) !== null && ref31 !== void 0 ? ref31 : undefined,
                postalCode: (ref32 = (ref22 = selectedStoreRef.current) === null || ref22 === void 0 ? void 0 : ref22.postalCode) !== null && ref32 !== void 0 ? ref32 : '',
                additionalAddressInfo: '',
                additionalStreetInfo: (ref33 = (ref23 = selectedStoreRef.current) === null || ref23 === void 0 ? void 0 : ref23.additionalStreetInfo) !== null && ref33 !== void 0 ? ref33 : '',
                countryCode: (ref34 = (ref24 = selectedStoreRef.current) === null || ref24 === void 0 ? void 0 : ref24.country) !== null && ref34 !== void 0 ? ref34 : '',
                externalId: (ref35 = (ref25 = selectedStoreRef.current) === null || ref25 === void 0 ? void 0 : ref25.globalStoreId) !== null && ref35 !== void 0 ? ref35 : undefined,
                company: (ref36 = (ref26 = selectedStoreRef.current) === null || ref26 === void 0 ? void 0 : ref26.name) !== null && ref36 !== void 0 ? ref36 : undefined
            });
        }
        // Default
        return mapGooglePayContactAddress(googlePayment);
    }, [
        cart,
        country,
        getLabel
    ]);
};

export { useMapShippingAddress };
//# sourceMappingURL=use-map-shipping-address.js.map
